import { motion } from 'framer-motion';
import { FaBriefcase } from 'react-icons/fa';
import { experience } from '../../data/experience';
import BlurFade from '../ui/BlurFade';

const Experience = () => {
  return (
    <section id="experience" className="bg-white py-20 text-black">
      <div className="mx-auto max-w-4xl px-6">
        <BlurFade>
          <h2 className="mb-10 text-2xl font-black sm:text-3xl">
            My <span className="text-black/30">Experience</span>
          </h2>
        </BlurFade>

        <div className="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2">
          {experience.map((job, i) => (
            <motion.div
              key={`${job.company}-${job.start}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              whileHover={{ y: -4, boxShadow: '0 8px 0 0 rgba(0,0,0,1)' }}
              transition={{ duration: 0.4, delay: (i % 4) * 0.05 }}
              className="flex h-full flex-col rounded-xl border-2 border-black bg-white p-5"
            >
              <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-1">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border-2 border-black">
                    <FaBriefcase size={14} />
                  </span>
                  <div>
                    <h3 className="font-black">{job.title}</h3>
                    <p className="text-sm text-black/60">{job.company} · {job.location}</p>
                  </div>
                </div>
                <span className="text-xs font-semibold text-black/50">{job.start} – {job.end}</span>
              </div>
              <p className="mt-3 flex-1 text-sm text-black/70">{job.description || '—'}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
